// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M9 3.5H13.5M9 8H13.5M9 12.5H13.5',
  'M3.5 3.5H5.5C6.05 3.5 6.5 3.95 6.5 4.5V6.5C6.5 7.05 6.05 7.5 5.5 7.5H3.5C2.95 7.5 2.5 7.05 2.5 6.5V4.5C2.5 3.95 2.95 3.5 3.5 3.5Z',
  'M2.5 11.1L3.9 12.5L6.5 9.9',
];
